var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PieChart',{staticClass:"PollResultsChartPie",attrs:{"width":450,"height":300,"chart-data":_vm.chartData,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }